import { Component } from "react";
import logo from "../../assets/images/mim-logo.png";

class FullPageLoader extends Component {
  render() {
    return (
      <div data-testid="full-page-loader" className="fp_loading_background">
        <img alt="MiM" src={logo} height="68" className="h-[68px]"></img>
        <div className="loader mt-3"></div>
      </div>
    );
  }
}

export default FullPageLoader;
